export default __webpack_public_path__ + "static/kb_de-09340b13e069c040a36bd7e80ce42640.jpg";